<script>
import {Doughnut} from 'vue-chartjs'
import 'chartjs-plugin-labels';

export default {
  name: "DoughnutChart",
  extends: Doughnut,
  props: {
    label: {
      type: String,
    },
    chartData: {
      type: Array
    },
    options: {
      type: Object
    }
  },
  mounted() {
    const dates = this.chartData.map(d => d.letter)
    const totals = this.chartData.map(d => d.total ? d.total : 0)
    this.renderChart({
      labels: dates,
      datasets: [
        {
          backgroundColor: ['#fe0100', '#fdae34', '#FEDD02', '#C2D82A', '#15A3E4', '#8B7964'],
          label: this.label,
          data: totals
        }
      ]
    }, this.options)
  },
}
</script>


<style scoped>
</style>
